function HealthProducts() {
    return(
        <>THis is the health product page </>
    )
}
export default HealthProducts;